'use strict';

var SMALL_DEVICE_MAX_WIDTH = 768;

exports.SMALL_DEVICE_MAX_WIDTH = SMALL_DEVICE_MAX_WIDTH;
